/** Client-side ids for sessions and messages. Falls back when `crypto.randomUUID` is missing (jsdom, old browsers). */
export function newId(prefix = 'id'): string {
  const cryptoObj: any = typeof globalThis !== 'undefined' ? (globalThis as any).crypto : undefined;
  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return `${prefix}-${cryptoObj.randomUUID()}`;
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
